import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7424ee07"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ba-left-side"
};
const _hoisted_2 = {
  class: "ba-product-info ba-product-info-regular"
};
const _hoisted_3 = ["src", "alt"];
const _hoisted_4 = {
  class: "details"
};
const _hoisted_5 = {
  class: "ba-text ba-text-small ba-text-left ba-text-lighter",
  style: {
    "line-height": "100%"
  }
};
const _hoisted_6 = {
  class: "ba-product-info-prioritized"
};
const _hoisted_7 = {
  class: "ba-product-data ba-product-data-bottom ba-product-data-regular"
};
const _hoisted_8 = {
  class: "ba-right-side",
  style: {
    "width": "unset"
  }
};
const _hoisted_9 = {
  class: "ba-perfomance ba-perfomance-bottom ba-perfomance-regular"
};
const _hoisted_10 = ["src", "alt"];
const _hoisted_11 = {
  class: "details"
};
const _hoisted_12 = {
  class: "ba-text ba-text-small ba-text-left ba-text-lighter",
  style: {
    "line-height": "100%"
  }
};
const _hoisted_13 = {
  class: "product-info-block"
};
const _hoisted_14 = {
  class: "inner-block"
};
const _hoisted_15 = {
  class: "state-and-algo-result"
};
const _hoisted_16 = {
  class: "title-flag-adtypes"
};
const _hoisted_17 = {
  class: "title"
};
const _hoisted_18 = {
  class: "flag-adtype"
};
const _hoisted_19 = ["src", "alt"];
const _hoisted_20 = {
  class: "adType"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ppc_b_a_state_cell = _resolveComponent("ppc-b-a-state-cell");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_ppc_b_a_product_info_cell = _resolveComponent("ppc-b-a-product-info-cell");
  const _component_ppc_b_a_s_b_portfolio_cell = _resolveComponent("ppc-b-a-s-b-portfolio-cell");
  const _component_ppc_b_a_prioritized_by_cell = _resolveComponent("ppc-b-a-prioritized-by-cell");
  const _component_ppc_b_a_product_margin_cell = _resolveComponent("ppc-b-a-product-margin-cell");
  const _component_ppc_b_a_boost_cell = _resolveComponent("ppc-b-a-boost-cell");
  const _component_ppc_b_a_acos_roas_cell = _resolveComponent("ppc-b-a-acos-roas-cell");
  const _component_ppc_b_a_s_b_budget_cell = _resolveComponent("ppc-b-a-s-b-budget-cell");
  const _component_ppc_b_a_max_potential_percent_cell = _resolveComponent("ppc-b-a-max-potential-percent-cell");
  const _component_ppc_b_a_vs_last_week_spend_cell = _resolveComponent("ppc-b-a-vs-last-week-spend-cell");
  const _component_app_modal = _resolveComponent("app-modal");
  const _component_ppc_budget_allocation_weekly_budget_edit = _resolveComponent("ppc-budget-allocation-weekly-budget-edit");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
    class: _normalizeClass(["ba-row sb-budget", $options.getRowClass])
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_ppc_b_a_state_cell, {
    item_id: `enabled${$options.processedItem.id}`,
    loading: $props.still_initializing || $data.edit_campaign_loading,
    state: $options.campaignState,
    onStateChange: _cache[0] || (_cache[0] = val => {
      this.onApplyCampaignStateEdit(val ? 'ENABLED' : 'PAUSED');
    })
  }, null, 8, ["item_id", "loading", "state"]), _createVNode(_component_ppc_b_a_product_info_cell, {
    name: $options.processedItem.name,
    image: $options.processedItem.image,
    item_id: `name${$options.processedItem.id}`,
    class: "sb_ba_product_info"
  }, {
    details: _withCtx(() => [$options.processedItem.flag ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      src: $options.processedItem.flag,
      class: "flag",
      alt: $options.processedItem.countryCode
    }, null, 8, _hoisted_3)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString($options.processedItem.adType), 1)])]),
    badge: _withCtx(() => [$options.processedItem.result && !['paused_unchanged', 'updated'].includes($options.processedItem.result) ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: _normalizeClass(['badge ba-text ba-text-small', {
        [$options.processedItem.result]: !!$options.processedItem.result
      }, {
        blocked: !$options.campaignState
      }])
    }, [_createVNode(_component_app_icon, {
      icon: "ai",
      size: 12
    }), _createTextVNode(" " + _toDisplayString($data.badgeTextMapping[$options.processedItem.result] ?? ""), 1)], 2)) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["name", "image", "item_id"]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_ppc_b_a_s_b_portfolio_cell, {
    item_id: `ai_enabled${$options.processedItem.id}`,
    loading: $props.still_initializing || $data.edit_campaign_loading,
    state: $options.campaignAIState,
    onStateChange: _cache[1] || (_cache[1] = val => {
      this.onApplyCampaignPortfolioEdit(val ? this.sb_portfolio.portfolioId.toString() : null);
    }),
    class: "sb_prioritized_cell"
  }, null, 8, ["item_id", "loading", "state"]), _createVNode(_component_ppc_b_a_prioritized_by_cell, {
    value: $options.processedItem.adsNetProfit4W,
    currency: $props.currency,
    precision: 0,
    allowPrecisionModification: false,
    type: "ads_net_profit",
    class: "sb_prioritized_cell"
  }, null, 8, ["value", "currency"])])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
    class: _normalizeClass(["ba-product-data-content", {
      last: $props.last
    }])
  }, [_createVNode(_component_ppc_b_a_product_margin_cell, {
    value: $options.processedItem.productsMarginValue,
    percentage_value: $options.processedItem.productsMargin,
    currency: $props.currency,
    class: "sb_ba_product_margin"
  }, null, 8, ["value", "percentage_value", "currency"]), _createVNode(_component_ppc_b_a_boost_cell, {
    value: $options.processedItem.boost,
    onBoostChange: $options.onBoostChange,
    class: "sb_ba_boost"
  }, null, 8, ["value", "onBoostChange"]), _createVNode(_component_ppc_b_a_acos_roas_cell, {
    mode: $props.mode,
    acos4W: $options.processedItem.acos4W,
    roas4W: $options.processedItem.roas4W,
    cap: $options.processedItem.cap,
    item_id: `cap-4w${$options.processedItem.id}`,
    class: _normalizeClass(['sb_ba_cap', {
      getCapColor: $options.getCapColor
    }])
  }, null, 8, ["mode", "acos4W", "roas4W", "cap", "item_id", "class"])], 2)])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
    class: _normalizeClass(["ba-perfomance-content", {
      last: $props.last
    }])
  }, [_createVNode(_component_ppc_b_a_s_b_budget_cell, {
    loading: $props.still_initializing || $data.edit_campaign_loading,
    value: $options.processedItem.weeklyBudget,
    ai_value: $options.processedItem.allocatedBudgetAI,
    currency_symbol: $options.currencySymbol,
    currency: $props.currency,
    currency_precision: $data.currency_precision,
    is_paused: !$options.campaignState,
    item_id: $options.processedItem.id,
    onBudgetChange: _cache[2] || (_cache[2] = () => {
      $data.budgetUpdateModal = true;
    }),
    onReset: _cache[3] || (_cache[3] = $event => $options.onApplyCampaignBudgetEdit({
      current: $options.processedItem.allocatedBudgetAI
    })),
    class: "sb_ba_budget"
  }, null, 8, ["loading", "value", "ai_value", "currency_symbol", "currency", "currency_precision", "is_paused", "item_id"]), _createVNode(_component_ppc_b_a_max_potential_percent_cell, {
    item_id: `potentialPerformance${$options.processedItem.id}`,
    value: $options.processedItem.maxSpendPotentialPercent,
    potential_budget: $options.processedItem.maxWeeklyBudget,
    current_budget: $options.processedItem.weeklyBudget,
    currency: $props.currency,
    currency_precision: $data.currency_precision,
    class: "sb_ba_potential"
  }, null, 8, ["item_id", "value", "potential_budget", "current_budget", "currency", "currency_precision"]), _createVNode(_component_ppc_b_a_vs_last_week_spend_cell, {
    item_id: `perfomancelastweek${$options.processedItem.id}`,
    value: $options.processedItem.vsLastWeekSpend,
    previous_week_value: $options.processedItem.lastWeekSpend,
    currency: $props.currency,
    currency_precision: $data.currency_precision,
    class: "sb_ba_last_week"
  }, null, 8, ["item_id", "value", "previous_week_value", "currency", "currency_precision"])], 2)])])], 2), _createVNode(_component_app_modal, {
    modelValue: $data.confirmModal,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.confirmModal = $event),
    title: "Confirm Campaign Update",
    "cancel-title": "No",
    "ok-title": "Yes",
    onOk: _cache[5] || (_cache[5] = $event => $options.onApplyCampaignEditConfirm()),
    custom_class: "confirm-block-modal-sb"
  }, {
    default: _withCtx(() => [_createVNode(_component_ppc_b_a_product_info_cell, {
      name: $options.processedItem.name,
      image: $options.processedItem.image,
      item_id: `name${$options.processedItem.id}`,
      class: "sb_ba_product_info"
    }, {
      details: _withCtx(() => [$options.processedItem.flag ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: $options.processedItem.flag,
        class: "flag",
        alt: $options.processedItem.countryCode
      }, null, 8, _hoisted_10)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString($options.processedItem.adType), 1)])]),
      _: 1
    }, 8, ["name", "image", "item_id"]), _createTextVNode(" " + _toDisplayString($data.confirm_modal_text), 1)]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_app_modal, {
    modelValue: $data.budgetUpdateModal,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.budgetUpdateModal = $event),
    title: "Budget allocation",
    custom_class: "budget-update-modal-sb",
    noCancel: "",
    noOk: "",
    noFooter: "",
    no_close_on_outside_click: ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", {
      class: "state-icon-container",
      style: _normalizeStyle(`background: ${{
        true: '#DEFBE6',
        false: '#f7de88'
      }[$options.campaignState]};`)
    }, [(_openBlock(), _createBlock(_resolveDynamicComponent({
      true: 'PlayIcon',
      false: 'PauseIcon'
    }[$options.campaignState]), {
      height: 20,
      width: 20,
      style: `background: inherit; border-radius: 13.75px;`
    }))], 4), $options.processedItem.result && !['paused_unchanged', 'updated'].includes($options.processedItem.result) ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: _normalizeClass(["algo-result", [{
        [$options.processedItem.result]: !!$options.processedItem.result
      }]])
    }, [_createVNode(_component_app_icon, {
      icon: "ai",
      size: 13,
      color: {
        inactive: '#484c51',
        paused: '#4c4848',
        activated: '#595959'
      }[$options.processedItem.result]
    }, null, 8, ["color"]), _createTextVNode(" " + _toDisplayString($data.badgeTextMapping[$options.processedItem.result] ?? ""), 1)], 2)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, _toDisplayString($options.processedItem.name), 1), _createElementVNode("div", _hoisted_18, [$options.processedItem.flag ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      src: $options.processedItem.flag,
      class: "flag",
      alt: $options.processedItem.countryCode
    }, null, 8, _hoisted_19)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_20, _toDisplayString($options.processedItem.adType), 1)])])])]), _createVNode(_component_ppc_budget_allocation_weekly_budget_edit, {
      data: {
        budgetCurrent: $options.processedItem.weeklyBudget,
        potential: $options.processedItem.maxSpendPotentialPercent,
        budgetAi: $options.processedItem.allocatedBudgetAI,
        evolution: $options.processedItem.vsLastWeekSpend,
        previous_week_spend: $options.processedItem.lastWeekSpend,
        budgetPotential: $options.processedItem.maxWeeklyBudget,
        campaigns: null
      },
      currency: $props.currency,
      country_code: $options.processedItem.countryCode,
      validationMultiplier: 1,
      open: "",
      type: "sponsored_brand",
      onApply: $options.onApplyCampaignBudgetEdit,
      onCancel: _cache[6] || (_cache[6] = () => {
        $data.budgetUpdateModal = false;
      })
    }, null, 8, ["data", "currency", "country_code", "onApply"])]),
    _: 1
  }, 8, ["modelValue"])], 64);
}